import type { GridPagination } from "@repo/ui";

export interface ComplaintsFilter extends GridPagination {
	// Date filters
	complaintDateAfter?: Date | null;
	complaintDateBefore?: Date | null;
	createdOnFrom?: Date | null;
	createdOnTo?: Date | null;
	enrollmentDateAfter?: Date | null;
	enrollmentDateBefore?: Date | null;

	// Text filters
	customerAccountNumber?: string;
	complaintType?: string;
	repId?: string;
	firstName?: string;
	lastName?: string;
	representativeFirstName?: string;
	representativeLastName?: string;
	esiId?: string;
	agentId?: string;
	customerName?: string;
	customerPhone?: string;
	complaintId?: string;

	// Dropdown filters
	status?: string;
	assignedStatus?: string;
	qaAnalystId?: number | null;
	sourceId?: number | null;
	reportingTagId?: number | null;
	complaintOrIncident?: number | null;
	commissionComplaint?: string;
	commodity?: string;
	ope?: string;

	// Multi-select filters
	typeId?: number[];

	// Branch filters (from partial)
	branchIds?: number[];
}

// Enums that match the MVC version
export enum RepIncidentStatus {
	Open = 0,
	Pending = 1,
	Complete = 2,
}

export enum RepIncidentAssignedStatus {
	Unassigned = 1,
	Assigned = 2,
	AssignedToMe = 3,
}

export enum CommodityTypeEnum {
	Electric = 0,
	Gas = 1,
	Both = 2,
}
